import BotoSeguir from 'components/3catinfo/BotoSeguir';

const Tag = (props) => {
    const { tag, segueix = true, tipologia, estil, tooltipInici } = props;
    const getTagSeguir = () => {
        return (
            segueix && (
                <BotoSeguir
                    estil={estil}
                    text={tag.desc}
                    textMissatge={tag.desc}
                    id={tag.idint}
                    textHitAudiencies={tag.desc}
                    tipologia={tipologia}
                    linkTipus={'web_actualitat_seccio'}
                    slug={tag.desc}
                    key={`TAGST${tag.id}`}
                    enviaApi={true}
                    isItemNoti={true}
                    tooltipInici={tooltipInici}
                />
            )
        );
    };

    return tag ? getTagSeguir() : <></>;
};

export default Tag;
